<!--
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
-->
<div class="content">
  <div class="heading">What are the system requirements for downloading and installing?</div>
  <div class="text">
    For downloading from Wind River Gallery, we use HTTPS which requires Port 443 to be open and access to our
    delivers.windriver.com domain. Our Installer uses the Webdav protocol to download additional data needed during
    installation. If your company restricts the download of archive files (ZIP or UDF), that may also prevent download.
  </div>
  <div class="text">
    Host system requirements can be found in the
    <a href="https://support2.windriver.com/" target="_blank">
      Wind River Product Installation and Licensing Administrator's Guide.
    </a>
  </div>

  <div class="heading">Common Issues</div>
  <div class="text">
    Your network configuration may prevent the delivery of Wind River software. This is most often caused by firewall or
    proxy server settings that block certain kinds of software installations. In addition, some networks are setup to
    throttle the bandwidth of large files preventing them from completing the download or block downloading of zip, udf,
    or exe file formats.
  </div>
  <div class="text">
    If you think you might have one of these issues, please contact your IT administrator to resolve the issue. Your IT
    Admin can usually resolve the issue by adjusting the proxy server settings. If your IT administrator cannot resolve
    the issue for you, contact
    <a href="http://www.windriver.com/support/" target="_blank"> Wind River Support. </a>
  </div>

  <button mat-raised-button (click)="close()">close</button>
</div>
